import { IPETest } from "../../data/interfaces"

interface IStepMonitorProps {
    item: IPETest
    current: number
    full:number
}
const StepsMonitor = (props: IStepMonitorProps): JSX.Element => {
    return <div className="pe-matching-steps-monitor-cont"data-testid="test-monitor">
        {
            Array(props.full).fill(1).map((__, i) => {
                return <div className={` step position-relative ${ i < props.current ? "past" : "" } `} key={ i } data-testid="test-monitor-step">
                    {
                        i === props.current - 1 &&
                        <div className="position-absolute top w-100 text-center" style={{ top: 5, zIndex: 100 }} data-testid="test-monitor-current-label">
                            <span className="bg-dark text-light px-1 py-0 small title aspect-ratio-1 flex-centered max-height-50">
                                { props.current }
                            </span>
                        </div>
                    }
                </div>
            })
        } 
    </div> 
}


export default StepsMonitor